import { render, staticRenderFns } from "./WidgetInstructionsFour.vue?vue&type=template&id=5ba495f2&"
import script from "./WidgetInstructionsFour.vue?vue&type=script&lang=js&"
export * from "./WidgetInstructionsFour.vue?vue&type=script&lang=js&"
import style0 from "./WidgetInstructionsFour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports